<div class="coupon-confirmation-modal" *transloco="let t">
    <div class="header">
        @if(accountCounponService.unsubmittedCoupon() || this.orderService.order().pendingSpecial || accountCounponService.pendingApplicationCoupon()) {
        <span class="title">{{t('modals.coupon_confirmation_modal.coupon_added_as_pending')}}</span>
        } @else {
        <span class="title">{{t('modals.coupon_confirmation_modal.coupon_successfully_applied')}}</span>
        }
        <button class="button-undecorated close-button" [attr.aria-label]="'Close Coupon Confirmation Modal'"
            (click)="closeModal()">
            <cwo-round-icon [iconName]="iconNameType.close" [size]="'medium'" />
        </button>
    </div>
    <div class="content">
        @if(accountCounponService.unsubmittedCoupon() || this.orderService.order().pendingSpecial || accountCounponService.pendingApplicationCoupon()) {
        <span class="coupon-message">
            {{t('modals.coupon_confirmation_modal.coupon_pending_message', { coupon: accountCounponService.unsubmittedCoupon()?.code ?? this.orderService.order().pendingSpecial?.name ?? accountCounponService.pendingApplicationCoupon()?.code})}}
            {{this.orderService.order().pendingSpecial?.name ? t('modals.coupon_confirmation_modal.follow_instructions_message') : null}}
        </span>
        } @else {
        <span class="coupon-message">
            {{t('modals.coupon_confirmation_modal.coupon_applied_message', { coupon: (orderService.order().specials ?? [])[0]?.special})}}
        </span>
        }
        <div class="modal-buttons-wrapper">
            @if(this.orderService.order().pendingSpecial) {
            <cwo-accent-button [accentButtonStyle]="accentButtonStyleType.DEFAULT" [ariaLabel]="'View Instructions'"
                [fullWidth]="true" (click)="handleInstruction()">
                <span>{{t('modals.coupon_confirmation_modal.view_instructions')}}</span>
            </cwo-accent-button>
            }

            <cwo-accent-button [accentButtonStyle]="accentButtonStyleType.CLEAR" [ariaLabel]="'Continue Shopping'"
                [fullWidth]="true" (click)="closeModal()">
                <span>{{t('modals.coupon_confirmation_modal.continue_shopping')}}</span>
            </cwo-accent-button>
        </div>
    </div>
</div>